<template>
    <div class="modial" v-show="isMotail">
      <div class="modial_in">
        <p class="title">{{ title }}</p>
        <p class="browser">{{ browser }}</p>
        <p class="direct">{{ direct }}</p>
      </div>
    </div>
</template>
<script>
export default {
    data(){
        return{} 
    },
    props:{
      title:String,
      browser:String,
      direct:String,
      isMotail:Boolean
    }
}
</script>
<style scoped>
.modial {
  width: 100%;
  position: fixed;
  left:0;
  top:0;
  background-color: rgba(0, 0, 0, 0.1);
  min-height: 38.875rem;
  background-size: cover;
  z-index:999;
}
.modial .modial_in {
  padding-left: 0.5rem;
  text-align: left;
  position: absolute;
  background: rgb(255, 255, 255);
  width: 8.75rem;
  height: 5rem;
  left: 50%;
  top: 40%;
  transform: translateX(-50%);
  border-radius: 0.5rem;
}
.modial .modial_in p {
  font-size: 0.5rem;
  margin-top: 0.5rem;
}
.modial .modial_in .title {
  font-size: 0.75rem;
  font-weight: bold;
}
</style>





// WEBPACK FOOTER //
// src/component/Motial.vue